import { gql } from '@apollo/client';

export const SCHEDULE_MAINTENANCE = gql`
  mutation ScheduleMaintenance($startDate: String!, $endDate: String) {
    scheduleMaintenance(startDate: $startDate, endDate: $endDate) {
      message
    }
  }
`;

export const END_MAINTENANCE = gql`
  mutation EndMaintenance($id: String!) {
    endMaintenance(id: $id) {
      message
    }
  }
`;

export const DELETE_MAINTENANCE = gql`
  mutation DeleteMaintenance($id: String!) {
    deleteMaintenance(id: $id) {
      message
    }
  }
`;
